import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Checkbox } from '../../Checkbox';
import { Typography } from '../../Typography';
import styles from './CheckboxWithLabel.module.scss';
export const CheckboxWithLabel = (param)=>{
    let { id, label, sublabel, checked, testId, className, ellipsis, onChange } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, {
            [styles.ellipsis]: ellipsis
        }, className),
        "data-testid": testId,
        children: /*#__PURE__*/ _jsx(Checkbox, {
            id: id,
            testId: "".concat(testId, "-checkbox"),
            onChange: onChange,
            checked: checked,
            noBi: true,
            children: /*#__PURE__*/ _jsxs("div", {
                className: styles.label,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: ellipsis,
                        children: label
                    }),
                    sublabel && /*#__PURE__*/ _jsx(Typography, {
                        skin: "secondary",
                        children: sublabel
                    })
                ]
            })
        })
    });
};
